var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1580920573319,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2142,
    width: 14,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 938.666667v-85.333334c0-158.464-96.469333-294.698667-233.728-353.322666A234.325333 234.325333 0 0 0 746.666667 320C746.666667 190.634667 641.365333 85.333333 512 85.333333a234.922667 234.922667 0 0 0-234.666667 234.666667c0 72.234667 32.896 136.917333 84.394667 180.010667C224.469333 558.634667 128 694.912 128 853.333333v85.333334h85.333333v-85.333334c0-164.650667 133.973333-298.666667 298.666667-298.666666 164.650667 0 298.666667 134.016 298.666667 298.666666v85.333334h85.333333zM362.666667 320C362.666667 237.653333 429.653333 170.666667 512 170.666667s149.333333 66.986667 149.333333 149.333333S594.346667 469.333333 512 469.333333 362.666667 402.346667 362.666667 320z",
    fill: "currentColor",
    "p-id": 2143
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.b982a58b82031d48e29f52df9a429aca.svg";
export { ForwardRef as ReactComponent };